import type { ExternalSystemDto, ExternalSystemInputDto, ExternalSystemPagedRequestDto, ExternalSystemQueueInformationDto } from './models';
import { RestService, Rest } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { PagedResultDto } from '../pagination/models';

@Injectable({
  providedIn: 'root',
})
export class ExternalSystemService {
  apiName = 'Default';
  

  createByInputDto = (inputDto: ExternalSystemInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/external-system',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  deleteByExternalSystemId = (externalSystemId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/app/external-system',
      params: { externalSystemId },
    },
    { apiName: this.apiName,...config });
  

  editByInputDto = (inputDto: ExternalSystemInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'POST',
      url: '/api/app/external-system/edit',
      body: inputDto,
    },
    { apiName: this.apiName,...config });
  

  getAllActiveExternalSystemsQueueInformation = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ExternalSystemQueueInformationDto[]>({
      method: 'GET',
      url: '/api/app/external-system/active-external-systems-queue-information',
    },
    { apiName: this.apiName,...config });
  

  getAllByInput = (input: ExternalSystemPagedRequestDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ExternalSystemDto>>({
      method: 'GET',
      url: '/api/app/external-system',
      params: { name: input.name, code: input.code, state: input.state, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getByIdByExternalSystemId = (externalSystemId: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ExternalSystemDto>({
      method: 'GET',
      url: `/api/app/external-system/by-id/${externalSystemId}`,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
